import { render, staticRenderFns } from "./AddToWishlist.vue?vue&type=template&id=0de4c2f5&scoped=true&"
import script from "./AddToWishlist.vue?vue&type=script&lang=ts&"
export * from "./AddToWishlist.vue?vue&type=script&lang=ts&"
import style0 from "./AddToWishlist.vue?vue&type=style&index=0&id=0de4c2f5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de4c2f5",
  null
  
)

export default component.exports